import { ofType, combineEpics } from "redux-observable";
import { switchMap, mergeMap, catchError } from "rxjs/operators";
import { Observable, of } from "rxjs";
import "rxjs-compat";
import experimentResource from "@ane/exp-data/lib/resources/ExperimentResources";
import MyActivitiesActions from "./MyActivitiesActions.js";
import myActivitiesActionTypes from "./MyActivitiesActionTypes.js";
import SearchLogPerformanceActions from "../../Common/logging/SearchLogPerformanceActions.js";
const getMyActivitiesExpEpic = (action$) => {
  return action$.pipe(
    ofType(myActivitiesActionTypes.GET_MY_EXPS),
    switchMap((value) => {
      return Observable.concat(
        of(SearchLogPerformanceActions.experimentSearchStart()),
        Observable.fromPromise(experimentResource.getAllExperiments(value.payload.address)).pipe(
          mergeMap((result) => {
            const data = result.getSuccessData().Results;
            const experiments = data.filter((val) => !val.IsFeatureRollout);
            const expIds = experiments.map((exp) => exp.Id);
            const featureRollouts = data.filter((val) => val.IsFeatureRollout);
            const featureRolloutIds = featureRollouts.map((exp) => exp.Id);
            return Observable.of(
              MyActivitiesActions.updateAllExpsAction(value.payload.queryType, result.getSuccessData()),
              SearchLogPerformanceActions.experimentSearchMainFunctionality(),
              MyActivitiesActions.fetchScorecardsAction(value.payload.queryType, expIds),
              MyActivitiesActions.fetchStatusAction(value.payload.queryType, featureRolloutIds),
              SearchLogPerformanceActions.experimentSearchFullLoad()
            );
          }),
          catchError((error) => of(MyActivitiesActions.updateAllExpsAction(value.payload.queryType, { Error: true })))
        )
      );
    })
  );
};
const myActivitiesEpics = combineEpics(getMyActivitiesExpEpic);
export {
  getMyActivitiesExpEpic,
  myActivitiesEpics
};
//# sourceMappingURL=MyActivitiesEpics.js.map
